export default {
  downtimeUrl: "https://cl.kodland.tech",
};

